import { cva } from "class-variance-authority";

const buttonVariants = cva(
  "inline-flex bg-neutral-200 border-neutral-100 items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none ",
  {
    variants: {
      variant: {
        default:
          "!bg-primary text-primary-foreground shadow-xs hover:bg-primary/90",
        destructive:
          "!bg-destructive text-white shadow-xs hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60",
        outline:
          "!border shadow-xs hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50",
        secondary:
          "!bg-secondary text-secondary-foreground shadow-xs hover:bg-secondary/80",
        ghost:
          "hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50",
        link: "text-primary underline-offset-4 hover:underline",
        blue: "!border-transparent bg-[#D9ECF8] text-[#2B6A7F]",
        green: "!border-transparent bg-[#D3F8DD] text-[#47864D]",
        yellow: "!border-transparent bg-[#FFF1C9] text-[#806B1A]",
        red: "!border-transparent bg-[#FFCCCD] text-[#7F2B2C]",
        gray: "!border-transparent bg-gray-200 text-gray-700",
      },
      size: {
        default: "h-9 px-4 py-2 has-[>svg]:px-3",
        sm: "h-8 rounded-md gap-1.5 px-3 has-[>svg]:px-2.5",
        lg: "h-10 rounded-md px-6 has-[>svg]:px-4",
        icon: "size-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);

const badgeVariants = cva(
  "inline-flex items-center justify-center rounded-md border px-2 py-0.5 text-xs font-medium w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none transition-[color,box-shadow] overflow-hidden",
  {
    variants: {
      variant: {
        default:
          "!border-transparent bg-primary text-primary-foreground [a&]:hover:bg-primary/90",
        secondary:
          "!border-transparent bg-secondary text-secondary-foreground [a&]:hover:bg-secondary/90",
        destructive:
          "!border-transparent bg-destructive text-white [a&]:hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60",
        outline:
          "text-foreground [a&]:hover:bg-accent [a&]:hover:text-accent-foreground",
        blue: "!border-transparent bg-[#D9ECF8] text-[#2B6A7F]",
        green: "!border-transparent bg-[#D3F8DD] text-[#47864D]",
        yellow: "!border-transparent bg-[#FFF1C9] text-[#806B1A]",
        red: "!border-transparent bg-[#FFCCCD] text-[#7F2B2C]",
        gray: "!border-transparent bg-gray-200 text-gray-700",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

const alertVariants = cva(
  "relative w-full rounded-lg border p-4 [&>svg~*]:pl-7 [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground",
  {
    variants: {
      variant: {
        default: "text-foreground",
        destructive:
          "border-destructive/50 text-destructive dark:border-destructive [&>svg]:text-destructive",
        red: "!border-transparent bg-[#FFCCCD] text-[#7F2B2C]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export { buttonVariants, badgeVariants, alertVariants };
